import HeartSVG from "@design-system/ui-icons/vanilla/Heart"
import { createIcon } from "../createIcon"

export const HeartIcon = createIcon(HeartSVG)
